import { render, staticRenderFns } from "./HotelVendor.vue?vue&type=template&id=6e7e3964&"
import script from "./HotelVendor.vue?vue&type=script&lang=js&"
export * from "./HotelVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports